/**
 * UI/UX utilities for common component configurations
 */

/**
 * Spinner configuration for loading indicators
 */
export class SpinnerConfig {
  /**
   * Default fullscreen spinner configuration
   * Used for major operations like form submissions
   */
  static readonly FULLSCREEN_SPINNER: any = {
    type: 'ball-spin-clockwise',
    size: 'large',
    bdColor: 'rgba(51, 51, 51, 0.8)',
    color: '#fff',
    fullScreen: true
  };

  /**
   * Inline spinner configuration
   * Used for smaller operations within components
   */
  static readonly INLINE_SPINNER: any = {
    type: 'ball-spin-clockwise',
    size: 'medium',
    bdColor: 'rgba(51, 51, 51, 0.5)',
    color: '#fff',
    fullScreen: false
  };

  /**
   * Application update spinner configuration
   * Used when displaying update notifications
   */
  static readonly APPLICATION_UPDATE_SPINNER: any = this.FULLSCREEN_SPINNER;

  /**
   * Money closing spinner configuration
   * Used when submitting money closing transactions
   */
  static readonly MONEY_CLOSING_SPINNER: any = this.FULLSCREEN_SPINNER;

  /**
   * Valuables closing spinner configuration
   * Used when submitting valuables closing transactions
   */
  static readonly VALUABLES_CLOSING_SPINNER: any = this.FULLSCREEN_SPINNER;
}
